import { render, staticRenderFns } from "./AddNewBusiness.vue?vue&type=template&id=4c6c268c&scoped=true&"
import script from "./AddNewBusiness.vue?vue&type=script&lang=js&"
export * from "./AddNewBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6c268c",
  null
  
)

export default component.exports